import React, { useEffect, useState, useRef } from "react";

import Head from "next/head";
import Link from "next/link";

import "animate.css";
import FaqSearchComponent from "../../components/FAQComponent/FaqSearchComponent";
import FooterNavComponent from "../../components/FooterComponent/FooterNavComponent/FooterNavComponent";
import GetInTouchComponent from "../../components/FooterComponent/GetInTouchComponent/GetInTouchComponent";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";
import styles from "../../styles/FAQ.module.css";
import { AxiosInstance, logout } from "../../utilities";

const FAQComponent = (props) => {
  const [pageListData, setPageListData] = useState(props?.cmsData);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isVisible, setIsVisible] = useState(true);
  const divRef = useRef();

  useEffect(() => {   
    window.addEventListener("scroll", listenToScroll);
    return () => 
       window.removeEventListener("scroll", listenToScroll); 
  }, [])
  const listenToScroll = () => {
    let heightToHideFrom = 100;
    const winScroll = document.body.scrollTop || 
        document.documentElement.scrollTop;
       
    if (winScroll > heightToHideFrom) { 
       isVisible &&      // to limit setting state only the first time         
         setIsVisible(false);
    } else {
         setIsVisible(true);
    }  
  };
  useEffect(() => {
    faqCategoryList();
  }, []);

  const faqCategoryList = (e) => {
    AxiosInstance(4008, "application/json")
      .get("/faq/categories")
      .then((resp) => {
        const response = resp && resp.data;
        if (
          response &&
          (response.status === 200 || response.status === "200")
        ) {
          setPageListData(response.data)
          //faqQuestion(response.data[0]._id);
        } else if (
          response &&
          (response.status === 400 || response.status === "400")
        ) {
        }
      })
      .catch((err) => {
        var error = err && err.response;
        if (error && (error.status === "403" || error.status === 403)) {
          logout();
        } else if (error && (error.status === "500" || error.status === 500)) {
          console.log("Error", error.msg);
        }
      });
  };
  return (
    <>
      <Head>
        <title>FAQ</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta name="description" content="" />
        <meta property="keywords" content="" />
        <meta property="og:title" content="FAQ" />
        <meta
          property="og:url"
          content="https://starlightbetanext.demo-fsit.com/"
        />
        <meta property="og:type" content="website" />
        <meta property="og:description" content="" />
        <link rel="canonical" href={`${process.env.BASE_URL}/faq`} />
      </Head>
      <HeaderComponent />
      <section className={`text-center ${styles.faq_section} fixed-nav`}>
        <h1 className={styles.faq_section_heading}>Hi! How can we Help you?</h1>
        <FaqSearchComponent {...props} mainPage={true} />
        <ul
        ref={divRef}
          className={`d-flex align-items-center justify-content-center flex-wrap ${styles.faq_section_list}`}
        >
          <li className={`d-flex align-items-center justify-content-between flex-column ${styles.faq_section_list_item}`}>
          <Link href={`/faq/listAll`}>
            <a >
            <img alt="All Faq"
                    src={`/assets/images/allFaqs.png`}
                    className={styles.faq_section_list_item_img}
                  />
                  <div className={styles.faq_section_list_item_text}> All Faq</div>
             </a></Link>
          </li>
          {pageListData.map((row, index) => (
            <li
              className={`d-flex align-items-center justify-content-between flex-column ${styles.faq_section_list_item}`}
              key={row._id}
            >
              <Link href={`/faq/${row.slug}`}>
                <a>
                  <img alt=""
                    src={`/assets/images/${row.slug}.png`}
                    className={styles.faq_section_list_item_img}
                  />
                  <div className={styles.faq_section_list_item_text}>
                    {row.categoryName.charAt(0).toUpperCase() +
                      row.categoryName.slice(1)}
                  </div>
                </a>
              </Link>
            </li>
          ))}
        </ul>
        {isVisible && (
          <div id="hide" className={styles.fade_background}>
            <a
              className={`scroll_down ${styles.band_scroll_down} `}
              onClick={() => {
                divRef.current.scrollIntoView({ behavior: "smooth" });
              }}
            >
              <div
                className="animate__animated
          animate__fadeInDown
        
          animate__duration-1s"
              >
                <div className="scroll_down_object">
                  {" "}
                  <span></span>{" "}
                </div>
              </div>
              <div
                className="animate__animated
          animate__fadeInUp
        
          animate__duration-1s"
              >
                <h6 className={`scroll_down_title ${styles.scroll_down_title}`}>
                  Scroll Down
                </h6>
              </div>
              <div
                className="animate__animated
          animate__fadeInUp
        
          animate__duration-1s"
              >
                <p className={`scroll_down_text ${styles.scroll_down_text}`}>
                  to discover more
                </p>
              </div>
            </a>
          </div>
        )}
      </section>

      <GetInTouchComponent />
      <FooterNavComponent />
    </>
  );
};

export default FAQComponent;

export async function getServerSideProps(context) {
  let cmsData = {};

  await AxiosInstance(4008, "application/json")
    .get("/faq/categories")
    .then((resp) => {
      const response = resp && resp.data;
      if (response && (response.status === 200 || response.status === "200")) {
        cmsData = response.data;
        // faqQuestion(response.data[0]._id);
      } else if (
        response &&
        (response.status === 400 || response.status === "400")
      ) {
      }
    })
    .catch((err) => {
      var error = err && err.response;
      if (error && (error.status === "403" || error.status === 403)) {
        logout();
      } else if (error && (error.status === "500" || error.status === 500)) {
        console.log("Error", error.msg);
      }
    });

  // const footerData = await _fetchFooterCmsData()

  return { props: { cmsData: cmsData || [] } };
}
